<template>
  <div class="token">
    <m4-dialog title="Token preview" size="md">
      <template v-slot:button>
        <m4-button tag="a" :variant="btnPreviewVariant" :size="btnPreviewSize" class="token__value">
          {{ value }}
        </m4-button>
      </template>
      <div class="token__full-preview">
        <span class="token__full-preview__data">{{ token }}</span>
        <m4-button @click="copyToClipboard" tag="a" variant="info-outline" size="sm" class="token__copy">
          <m4-icon icon="copy"></m4-icon>
        </m4-button>
        <div v-if="copying" class="token__copying">
          <div>copied to clipboard</div>
        </div>
      </div>
    </m4-dialog>
    <m4-button @click="copyToClipboard" tag="a" variant="info-outline" :size="btnPreviewSize" class="token__copy">
      <m4-icon icon="copy"></m4-icon>
    </m4-button>
    <div v-if="copying" class="token__copying">
      copied to clipboard
    </div>
  </div>
</template>

<script>
export default {
  name: "M4Token",
  data() {
    return {
      copying: false
    };
  },
  props: {
    token: String,
    btnPreviewVariant: {
      type: String,
      default() {
        return "dark-outline";
      }
    },
    btnPreviewSize: {
      type: String,
      default() {
        return "sm";
      }
    },
    tokenLength: {
      type: Number,
      default() {
        return 8;
      }
    }
  },
  computed: {
    value() {
      let length = this.tokenLength / 2;
      return this.token.substring(0, length) + "....." + this.token.substring(this.token.length - length);
    }
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.token);
      this.copying = true;
      setTimeout(() => {
        this.copying = false;
      }, 1500);
    }
  }
};
</script>
